import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var svg = function svg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "2",
    fill: "none",
    d: "M 0.53 9.00 L 5.89 14.33 L 17.25 2.93"
  }));
};

export default svg;